import { createAction } from '@reduxjs/toolkit';

export {
    selectDriverTab,
    selectVehicleTab,
    setSelectedDriverGroups,
    setSelectedDrivers,
    setSelectedFuelTypeGroups,
    setSelectedVehicleGroups,
    setSelectedVehicles,
    setShowEmptyGroups,
} from './reducer';

export const expandTree = createAction('forest/private/EXPAND_TREE');

export const collapseTree = createAction('forest/private/COLLAPSE_TREE');
